var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAntDesignEditFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0781 28.5742H4.92188C4.31689 28.5742 3.82812 29.063 3.82812 29.668V30.8984C3.82812 31.0488 3.95117 31.1719 4.10156 31.1719H30.8984C31.0488 31.1719 31.1719 31.0488 31.1719 30.8984V29.668C31.1719 29.063 30.6831 28.5742 30.0781 28.5742ZM8.80811 25.7031C8.87647 25.7031 8.94482 25.6963 9.01318 25.686L14.7622 24.6777C14.8306 24.6641 14.8955 24.6333 14.9434 24.582L29.4321 10.0933C29.4638 10.0616 29.489 10.0241 29.5061 9.98273C29.5233 9.94138 29.5321 9.89706 29.5321 9.85229C29.5321 9.80753 29.5233 9.76321 29.5061 9.72186C29.489 9.68051 29.4638 9.64295 29.4321 9.61133L23.7515 3.92725C23.6865 3.8623 23.6011 3.82812 23.5088 3.82812C23.4165 3.82812 23.3311 3.8623 23.2661 3.92725L8.77734 18.416C8.72607 18.4673 8.69531 18.5288 8.68164 18.5972L7.67334 24.3462C7.64009 24.5293 7.65197 24.7177 7.70795 24.8952C7.76394 25.0727 7.86233 25.2339 7.99463 25.3647C8.22021 25.5835 8.50391 25.7031 8.80811 25.7031Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAntDesignEditFilled);
export default __webpack_public_path__ + "static/media/ant-design_edit-filled.7d6f3319.svg";
export { ForwardRef as ReactComponent };